import { useState } from 'react';
import { EvaluationStatusClient, EvaluationStatusDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useEvaluationStatusApi = () => {
    const apiClient = new EvaluationStatusClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: EvaluationStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createEvaluationStatus(data);
        } catch (err: any) {
            setError(err.message || 'Error creating EvaluationStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: EvaluationStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateEvaluationStatus(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating EvaluationStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getEvaluationStatusById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching EvaluationStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchEvaluationStatuses(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching EvaluationStatuses');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteEvaluationStatus(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting EvaluationStatus');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};